export default class IdTokenPayload {
    public acr = 0;
    public aud = '';
    public authTime = 0;
    public azp = '';
    public email = '';
    public emailVerified = false;
    public exp = 0;
    public familyName = '';
    public givenName = '';
    public iat = 0;
    public iss = '';
    public jti = '';
    public memberOf: string[] = [];
    public name = '';
    public preferredUsername = '';
    public sessionState = '';
    public sub = '';
    public typ = '';

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.acr) {
            this.acr = model.acr;
        }
        if (model.aud) {
            this.aud = model.aud;
        }
        if (model.authTime) {
            this.authTime = model.authTime;
        }
        if (model.auth_time) {
            this.authTime = model.auth_time;
        }
        if (model.azp) {
            this.azp = model.azp;
        }
        if (model.email) {
            this.email = model.email;
        }
        if (model.emailVerified) {
            this.emailVerified = model.emailVerified;
        }
        if (model.email_verified) {
            this.email = model.email_verified;
        }
        if (model.exp) {
            this.exp = model.exp;
        }
        if (model.familyName) {
            this.familyName = model.familyName;
        }
        if (model.family_name) {
            this.familyName = model.family_name;
        }
        if (model.givenName) {
            this.givenName = model.givenName;
        }
        if (model.given_name) {
            this.givenName = model.given_name;
        }
        if (model.iat) {
            this.iat = model.iat;
        }
        if (model.iss) {
            this.iss = model.iss;
        }
        if (model.jti) {
            this.jti = model.jti;
        }
        if (model.memberOf) {
            this.memberOf = model.memberOf;
        }
        if (model.member_of) {
            this.memberOf = model.member_of;
        }
        if (model.name) {
            this.name = model.name;
        }
        if (model.preferredUsername) {
            this.preferredUsername = model.preferredUsername;
        }
        if (model.preferred_username) {
            this.preferredUsername = model.preferred_username;
        }
        if (model.sessionState) {
            this.sessionState = model.sessionState;
        }
        if (model.sub) {
            this.sub = model.sub;
        }
        if (model.typ) {
            this.typ = model.typ;
        }
    }
}
